import { Injectable } from '@angular/core';
import { CustomerService } from 'src/api/services/customer.service';
import { Customer } from 'src/api/models/customer';
import { BehaviorSubject, Observable, Subscription, firstValueFrom } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';
import { CommandService, FireForesightService, SiteTwinService } from 'src/api/services';
import { Camera, Incident, MapLayerItem, ResponsibleParty, SiteTwin, StatusType } from 'src/api/models';
import { ApplicationConfigService } from './application-config.service';
import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { AzureAuthService } from './azure-auth.service';
import { SmartImageDetail } from 'src/app/components/smart-image-list/smart-image-list.component';



@Injectable()
export class FireService {
    public connection: HubConnection;

    public statusTypes: StatusType[];
    public responsibleParties: ResponsibleParty[];
    public visibleStatusTypes: StatusType[];
    public incidents: Incident[];
    public incidentsByStatus: {[key: number]: Incident[]} = {};
    public detectionImages: {[key: number]: SmartImageDetail[]} = {};
    public incident: Incident;
    public unconfirmed: Incident[];
    public cameras: Camera[]
    public camera: Camera;
    public twin: SiteTwin;
    public remoteData: Observable<Incident[]>;
    private _remoteData: BehaviorSubject<Incident[]>;
    public layers: MapLayerItem[];

    constructor(
        private readonly service: FireForesightService,
        private readonly siteService: SiteTwinService,
        private app: ApplicationConfigService,
        private authService: AzureAuthService) {
      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();

      this.reconnect();
    }

    reconnect(){
      if (this.connection == null){
        this.connection = new HubConnectionBuilder()
          .withUrl('hubs/FireForesight',{
            accessTokenFactory: () => this.authService.getToken()
          })
          .withAutomaticReconnect()
          //.withHubProtocol()
          .configureLogging(LogLevel.Information)
          .build();
          this.startConnection().then(() => {
          this.connection.on('ReceiveMessage', (user, message) =>
          {
            console.log("ReceiveMessage", message);
          });
        });
      }else{
        this.startConnection();
      }
    }

    private watchInterval: any;
    watch(){
      /*if (this.watchInterval == null){
        this.watchInterval = setInterval(() => {
          this.incidentsLoadStarted = false;
          this.getIncidents();
        }, 60 * 1000);
      }*/
    }

    stopWatch(){
      /*if (this.watchInterval != null){
        clearInterval(this.watchInterval);
        this.watchInterval = null;
      }*/
    }

    get(full: boolean) {
      this.getIncidents();
      if (this.cameras == null || full){
        this.getCameras();
        this.service.FireForesightGetStatusTypes().subscribe(results =>{
          this.statusTypes = results;
          this.visibleStatusTypes = results.filter(r => r.visible);
        });
        /*this.service.FireForesightGetMapLayers(this.app.customerId).subscribe(layers => {
          this.layers = layers;
        })*/
        this.service.FireForesightGetResponsibleParties(this.app.customerId).subscribe(results => {
          this.responsibleParties = results;
        });
      }
    }

    public incidentsLoadStarted: boolean = false;
    async getIncidents(){
      if (!this.incidentsLoadStarted){
        this.incidentsLoadStarted = true;
        this.detectionImages = {};
        this.incidentsByStatus = {};
        try {
          const results = await firstValueFrom(this.service.FireForesightGetIncidents({customerId: this.app.customerId, siteUri:null, statusId:null}));
          this._remoteData.next(results);
          for (let i of results){
            (i as any).shown = false;
          }
          this.incidents = results;
          this.incidentsLoadStarted = false;
          console.log("Incidents Loaded");
          this.unconfirmed = results.filter(i => i.status.statusId == 1)
          /*for (let status of this.statusTypes){
            this.incidentsByStatus[status.statusId] = results.filter(i => i.status.statusId == status.statusId);
          }
          for (let incident of this.incidents){
            if (incident.detections){
              this.detectionImages[incident.incidentId] = incident.detections.map(i => { return { src: i.imageUrl, overlay: i.detectionMetaData, timeStamp: i.firstDetected } as SmartImageDetail });
            }
          }*/
        } catch (err) {
          this.incidentsLoadStarted = false;
          throw err;
        }
      }
    }

    async getIncidentByStatus(statusId: number){
      if (!this.incidentsLoadStarted){
        this.incidentsLoadStarted = true;
        this.detectionImages = {};
        this.incidentsByStatus = {};
        try {
          const results = await firstValueFrom(this.service.FireForesightGetIncidents({customerId: this.app.customerId, siteUri:null, statusId:statusId}));
          this._remoteData.next(results);
          for (let i of results){
            (i as any).shown = false;
          }
          this.incidents = results;
          this.incidentsLoadStarted = false;
          console.log("Incidents Loaded");
          this.unconfirmed = results.filter(i => i.status.statusId == 1)
          for (let status of this.statusTypes){
            this.incidentsByStatus[status.statusId] = results.filter(i => i.status.statusId == status.statusId);
          }
          for (let incident of this.incidents){
            if (incident.detections){
              this.detectionImages[incident.incidentId] = incident.detections.map(i => { return { src: i.imageUrl, overlay: i.detectionMetaData, timeStamp: i.firstDetected } as SmartImageDetail });
            }
          }
        } catch (err) {
          this.incidentsLoadStarted = false;
          throw err;
        }
      }
    }

    public cameraLoadStarted: boolean = false;
    getIncident(incidentId: number, onComplete){
      this.service.FireForesightGetIncident({customerId: this.app.customerId, incidentId: incidentId}).subscribe(i => {
        this.incidentsLoadStarted = false;
        this.incident = i;
        if (this.incidents != null){
          var match = this.incidents.findIndex(i => i.incidentId == this.incident.incidentId);
          if (match > -1){
            this.incidents[match].confidence = 11;
            this.incidents[match] = this.incident;
          }
        }
        console.log("Incident Loaded")

        onComplete(i);
      });
    }

    getCameras(){
      this.cameraLoadStarted = true;
      this.service.FireForesightGetCameras(this.app.customerId).subscribe(cameras => {
          this.cameras = cameras;
          this.cameraLoadStarted = false;
      }, err => {
        this.cameraLoadStarted = false;
      });
    }

    getCameraSubscription: Subscription;
    getCamera(siteId: number, readOnly: boolean, onComplete){
      if (this.getCameraSubscription && !this.getCameraSubscription.closed){
        this.getCameraSubscription.unsubscribe();
        console.log("Cancel getCamera");
      }
      console.log("getCamera()");
      this.getCameraSubscription = this.service.FireForesightGetCamera({customerId:this.app.customerId, siteId:siteId}).subscribe(i => {
        if (!readOnly){
          this.camera = i;
          this.twin = this.camera.twin;
        }
        onComplete(i);
      });
    }

    getCameraByUriSubscription: Subscription;
    getCameraByUri(siteUri: string, onComplete){
      if (this.getCameraByUriSubscription && !this.getCameraByUriSubscription.closed){
        this.getCameraByUriSubscription.unsubscribe();
        console.log("Cancel getCameraUri");
      }
      console.log("getCameraByUri()");
      this.getCameraByUriSubscription = this.service.FireForesightGetCameraByUri({customerId:this.app.customerId, siteUri:siteUri}).subscribe(i => {
        this.camera = i;
        this.twin = this.camera.twin;
        onComplete(i);
      });
    }

    update(incident: Incident, onSuccess) {
      return this.service.FireForesightUpdateIncident(incident).subscribe(i => {
        var match = this.incidents.find(i => i.incidentId == incident.incidentId);
        match.status.colour = incident.status.colour;
        match.status.description = incident.status.description;
        match.status.displayName = incident.status.displayName;
        match.status.statusId = incident.status.statusId;
        match.status.visible = incident.status.visible;
        match.notes = i.notes;
        onSuccess();
      });
    }

    //proposed BH changes
    //getUpdate(incident: Incident)
    //{
    //  return this.service.FireForesightUpdateIncident(incident);
    //}

    //setUpdate(incident: Incident)
    //{
    //  var match = this.incidents.find(i => i.incidentId == incident.incidentId);
    //  match.status.colour = incident.status.colour;
    //  match.status.description = incident.status.description;
    //  match.status.displayName = incident.status.displayName;
    //  match.status.statusId = incident.status.statusId;
    //  match.status.visible = incident.status.visible;

    //}

    next(onComplete){
      console.log('next');
      var index = this.incidents.findIndex(i => i.incidentId == this.incident.incidentId);
      if (this.incidents.length > index){
        for (var i = index+1; i < this.incidents.length; i++){
          var inc = this.incidents[i];
          if (inc.status.statusId == 1){
            this.getIncident(inc.incidentId, onComplete);
            return;
          }
        }
        /*var newi = this.incidents[index+1];
        if (newi){
          this.getIncident(newi.incidentId, onComplete)
        }*/
      }
    }

    RunCommand(params: CommandService.CommandRunCommandParams): Promise<void> {
      if (this.connection.state != HubConnectionState.Connected){
        this.reconnect();
      }
      return this.connection.invoke('SendCommand', params.customerId, params.command);
    }

    public startConnection(): Promise<void> {
      return this.connection.start();
    }

    public stopConnection(): Promise<void> {
      return this.connection.stop();
    }

}
